import type { DeepPartial } from "simplytyped";
import { z } from "zod";
import { UserMeZod } from "../api/engage/engage.types";
import type { ShellUser } from "../api/types";

// Derive the update stream user payload from the regular User payload.
const UpdateStreamUserUpdatePayloadZod = UserMeZod.omit({
  channels: true,
  activeChannel: true,
  activeProject: true,
  rights: true, // may or may not be set.. appears to not be set for some users
}).extend({
  projects: z.number().array(),
  /** @deprecated Use the projects key with project ids instead of this. */
  channels: z.unknown(),
});

export const UpdateStreamUserUpdateMetaZod = z
  .object({
    meta: z.object({
      name: z.number(),
      agent_id: z.number(),
      channel_id: z.number(),
      rest: z.number(),
      method: z.literal("put"),
      action: z.literal("agent"),
      affected_agent: z.literal(""),
    }),
    payload: z.unknown(),
  })
  .passthrough();

export const UpdateStreamUserUpdateZod = UpdateStreamUserUpdateMetaZod.extend({
  payload: UpdateStreamUserUpdatePayloadZod,
});

export type UpdateStreamUserUpdate = Omit<
  z.infer<typeof UpdateStreamUserUpdateZod>,
  "payload"
> & {
  payload: DeepPartial<z.infer<typeof UpdateStreamUserUpdateZod>["payload"]>;
};

/**
 * A more light weight function that only checks the meta object, trying to
 * figure out if we should bother with parsing the payload or not.
 */
export const isUpdateStreamUserUpdateMessage = (
  message: unknown
): message is z.infer<typeof UpdateStreamUserUpdateMetaZod> =>
  UpdateStreamUserUpdateMetaZod.safeParse(message).success;

export const isUserUpdateRelatedToUser = (
  message: UpdateStreamUserUpdate,
  user?: ShellUser
) =>
  !!user &&
  user.id !== undefined &&
  user.id === message?.payload?.id?.toString();
